"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level2StateDTO = void 0;
const enums_1 = require("../enums");
class Level2StateDTO {
    constructor() {
        // the count of first tries made in this instance of the level.
        this.firstTries = 0;
        // current number of points the player has on the level.
        this.points = 0;
        // maximum number of points possible for the level.
        this.maxPoints = 0;
        // the organisms that are yet to be placed in a tile
        this.notPlaced = [];
        // the current status of the level.
        this.status = enums_1.LevelStatus.START;
        // the tile connections (filled and not filled)
        this.tileConnections = [];
        // the tiles (empty and filled)
        this.tiles = [];
        // number of points required to reach next level.
        this.unlockPoints = 0;
    }
}
exports.Level2StateDTO = Level2StateDTO;
//# sourceMappingURL=Level2StateDTO.js.map